"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _ = require("lodash");
const variable_1 = require("../model/variable");
const constraint_1 = require("../model/constraint");
const expression_1 = require("../model/expression");
class ExpressionGenerator {
    constructor(store) {
        this.store = store;
    }
    addVariable(expression) {
        return this.store.addVariable(this.parseVar(expression));
    }
    addConstraint(ownerUri, expression, isDirected = false) {
        let parts = expression.split('=>');
        let vars = _.initial(parts).map(v => this.parseVar(v));
        let exp = new expression_1.Expression(_.trim(_.last(parts)), isDirected);
        return this.store.addConstraint(ownerUri, new constraint_1.Constraint(vars, exp));
    }
    parseVar(string) {
        if (string.indexOf(' : ') >= 0) {
            if (string.indexOf(', ') >= 0) {
                return this.parseExpressionVar(string);
            }
            return this.parseTypedVar(string);
        }
        return this.parseSetBasedVar(string);
    }
    parseExpressionVar(string) {
        let parts = string.split(', ');
        let [name, type] = this.parseNameAndType(parts[0]);
        let expressions = _.tail(parts).map(p => new expression_1.Expression(_.trim(p)));
        return new variable_1.ExpressionVariable(name, type, ...expressions);
    }
    parseTypedVar(string) {
        let [name, type] = this.parseNameAndType(string);
        return new variable_1.TypedVariable(name, type);
    }
    parseSetBasedVar(string) {
        let parts = string.split(' in ');
        let name = this.parseVarName(parts[0]);
        let set = JSON.parse(parts[1]);
        return new variable_1.SetBasedVariable(name, set);
    }
    parseNameAndType(string) {
        let parts = string.split(' : ');
        let name = this.parseVarName(parts[0]);
        let type = _.trim(parts[1]);
        return [name, type];
    }
    parseVarName(string) {
        return _.trim(string.replace('∀', ''));
    }
}
exports.ExpressionGenerator = ExpressionGenerator;
function forAll(varName, state = []) {
    return new IntermediateQuantifier(varName, state);
}
exports.forAll = forAll;
class IntermediateQuantifier {
    constructor(name, state = []) {
        this.name = name;
        this.state = state;
    }
    in(...domain) {
        return new ScopedIntermediateQuantifier(new variable_1.SetBasedVariable(this.name, domain), this.state);
    }
    ofType(uri) {
        return new ScopedIntermediateQuantifier(new variable_1.TypedVariable(this.name, uri), this.state);
    }
    ofTypeWith(typeUri, ...withExpression) {
        return new ScopedIntermediateQuantifier(new variable_1.ExpressionVariable(this.name, typeUri, ...withExpression.map(e => new expression_1.Expression(e)) // TODO what about direction?
        ), this.state);
    }
}
exports.IntermediateQuantifier = IntermediateQuantifier;
class ScopedIntermediateQuantifier {
    constructor(domain, stateSoFar = []) {
        this.state = [
            ...stateSoFar,
            domain
        ];
    }
    forAll(varName) {
        return forAll(varName, this.state);
    }
    assert(exp, isDirected = false) {
        return new constraint_1.Constraint(this.state, new expression_1.Expression(exp, isDirected));
    }
}
exports.ScopedIntermediateQuantifier = ScopedIntermediateQuantifier;



//////////////////
// WEBPACK FOOTER
// ./~/dymo-core/lib/generator/expression-generator.js
// module id = 1298
// module chunks = 3